import { Tooltip, Typography } from '@mui/material';
import clsx from 'clsx';
import { useState } from 'react';

import styles from './OCRReviewDialog.module.scss';


export function SSNDisplay({ ssn, className }: { ssn: string, className?: string }) {
    const [ hideSSN, setHideSSN ] = useState(true);

    const toggleSSNVisibility = () => {
        setHideSSN(!hideSSN);
    };

    const formatSSN = () => {
        if (!ssn) {
            return 'N/A';
        }

        return hideSSN ? `*-${ssn.slice(-4)}` : ssn;
    };

    return (
        <Tooltip title={hideSSN ? 'Reveal' : 'Hide'}>
            <Typography
                onClick={toggleSSNVisibility}
                variant="body2"
                className={clsx(className, styles.ssnDisplay)}
            >
                {formatSSN()}
            </Typography>
        </Tooltip>
    );
}
